import { important } from "@nvon/react-toolbox";
import type { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { makeStyles } from "tss-react/mui";
import { defaultLanguage, Language } from "../config/LanguageConfiguration";
import { NWONPage } from "../config/NWONPage";
import NWONHeroSection from "../src/components/03-organisms/NWONHeroSection/NWONHeroSection";
import NWONSection from "../src/components/03-organisms/NWONSection/NWONSection";
import { NWONInitial } from "../src/components/NWONInitial/NWONInitial";
import { useImprint } from "../src/data/imprint";
import { isLanguage } from "../src/helpers/general/isLanguage";
import { useI18nActiveLanguage } from "../src/hooks/useI18nActiveLanguage";
import { defaultNameSpaces } from "../src/i18n/i18n-namespaces";
import { GetStaticPropsDefault } from "../src/interfaces/GetStaticPropsDefault";

const useImprintStyles = makeStyles()((theme) => ({
  section: {
    "& *": {
      width: "100%",
    },
    "& h2:first-child": {
      marginTop: important(0),
    },
    "& h2:not(:first-child)": {
      marginTop: theme.spacing(2),
    },
    "& p": {
      marginTop: 0,
    },
  },
}));

const Imprint: NextPage = () => {
  const activeLanguage = useI18nActiveLanguage();
  const imprint = useImprint();
  const { classes } = useImprintStyles();

  return (
    <NWONInitial pageInformationData={{ page: NWONPage.Imprint }}>
      <NWONHeroSection
        title={imprint.title[activeLanguage]}
        ctaButtonDisabled={true}
      />

      <NWONSection className={classes.section}>
        {imprint.text[activeLanguage]}
      </NWONSection>
    </NWONInitial>
  );
};

export const getStaticProps: GetStaticPropsDefault = async (context) => {
  const locale = isLanguage(context.locale) ? context.locale : defaultLanguage;

  return {
    props: {
      ...(await serverSideTranslations(locale, defaultNameSpaces, null, [
        Language.German,
        Language.English,
      ])),
    },
  };
};

export default Imprint;
